<template>
  <div class="">
    <div v-if="showTryOut" class="home-tryout-mask" @click.self="closeTryOut">
      <div class="home-tryout-dialog">
        <button
          type="button"
          class="home-tryout-close"
          aria-label="Close PWstudio trial popup"
          @click="closeTryOut"
        >
          &times;
        </button>
        <img
          class="home-tryout-img"
          src="../../assets/home/PWstudio-TryOut.png"
          alt="PWstudio Try Out"
          @click="toPWstudioIntroduce"
        >
      </div>
    </div>
    <HomeCarousel class="carousel-web"></HomeCarousel>
    <HomeCarouselMobile class="carousel-mobile"></HomeCarouselMobile>
    <HomeProduct></HomeProduct>
    <PWStudio></PWStudio>
    <Intellimat></Intellimat>
    <HomeAbout></HomeAbout>
    <!-- <HomeNews v-if="$i18n.locale === 'zh'"></HomeNews> -->
    <HomeNews></HomeNews>
    <HomeHonor></HomeHonor>
    <HomeEcological></HomeEcological>
    <HomeStrategic></HomeStrategic>
    <HomeCooperate></HomeCooperate>
  </div>
</template>

<script>
  import HomeCarousel from './HomeCarousel'
  import HomeCarouselMobile from './HomeCarouselMobile'
  import HomeAbout from './HomeAbout'
  import Intellimat from './Intellimat'
  import PWStudio from './PWStudio'
  import HomeProduct from './HomeProduct'
  import HomeNews from './HomeNews'
  import HomeHonor from './HomeHonor'
  import HomeEcological from './HomeEcological'
  import HomeStrategic from './HomeStrategic'
  import HomeCooperate from './HomeCooperate'

export default {
  name: 'HelloWorld',
  props: {

  },
  components: {
    HomeCarousel,
    HomeCarouselMobile,
    HomeAbout,
    PWStudio,
    Intellimat,
    HomeProduct,
    HomeNews,
    HomeHonor,
    HomeEcological,
    HomeStrategic,
    HomeCooperate
  },
  data() {
    return {
      showTryOut: sessionStorage.getItem('pwstudioTryOutSeen') !== 'true',
    }
  },
  methods: {
    closeTryOut() {
      this.showTryOut = false
      sessionStorage.setItem('pwstudioTryOutSeen', 'true')
    },
    toPWstudioIntroduce() {
      this.closeTryOut()
      this.$router.push({ name: 'PWstudioIntroduce' })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .home-tryout-mask {
    position: fixed;
    inset: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.55);
    padding: 24px;
  }
  .home-tryout-dialog {
    position: relative;
    max-width: min(630px, 88vw);
    max-height: 88vh;
  }
  .home-tryout-img {
    display: block;
    width: 100%;
    height: auto;
    max-height: 88vh;
    object-fit: contain;
    cursor: pointer;
  }
  .home-tryout-close {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.2);
    color: #d9d9d9;
    font-size: 32px;
    line-height: 32px;
    cursor: pointer;
  }
  .home-tryout-close:hover {
    background: rgba(0, 0, 0, 0.4);
  }
  .carousel-web{

  }
  .carousel-mobile{
    display: none;
  }


  @media (max-width: 768px) {

    .carousel-web{
      display: none;
    }
    .carousel-mobile{
      display: block;
    }
  }



</style>
